
define('modules/application/calculationClasses/energyManagement',[
  "app",

  // Libs
  "backbone"
],

function(app, Backbone) {

  var CalculationClass    = {};

  CalculationClass.resetValues               =  function() {
    //Resetting values
    BticinoS4B.solution.energyManagement.externalItems = [];
    BticinoS4B.solution.energyManagement.zonesItems    = [];
    BticinoS4B.solution.energyManagement.internals     = [];
    BticinoS4B.Instances.Models.ApplicationModel.set("externalItems", []);
    BticinoS4B.Instances.Models.ApplicationModel.set("zonesItems",    []);
    BticinoS4B.Instances.Models.ApplicationModel.set("internals",     []);
  };

  CalculationClass.startAutomaticCalculation =  function() {
    CalculationClass.resetValues();

    //Requesting model delivery
    window.BticinoS4B.eventAggregator.trigger("modelDeliver:request",this);
    window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested",this);

    var automaticCalculationModel = {externalItems : [], zones : []};
    var energyManagementSystemSelection, mainBus, advancedCommands, zigbeeRadio, energyManagementRemoteControls, integrationDevices;
    var k = 1, l=0, i=0, j=0, m=0;

    if (!automaticCalculationModel.automaticItems)
      automaticCalculationModel.automaticItems = [];

    var extractItem = function(baseModel, progNumber) {
      if (baseModel.attributes)
        return {
          progNumber        : progNumber,
          packageClassId    : baseModel.get("packageClassId"),
          partOfKit         : baseModel.get("partOfKit"),
          productCode       : baseModel.get("productCode"),
          productLabel      : baseModel.get("productLabel"),
          packageClassLabel : baseModel.get("packageClassLabel"),
          quantity          : (baseModel.get("value") && (baseModel.get("value")!==true)) ? baseModel.get("value") : 1,
          specialVars       : baseModel.get("specialVars") ? baseModel.get("specialVars") : {},
          price             : baseModel.get("price")
        };
      else
        return {
          progNumber        : progNumber,
          packageClassId    : baseModel.packageClassId,
          partOfKit         : baseModel.partOfKitId,
          productCode       : baseModel.productCode,
          productLabel      : baseModel.productLabel,
          packageClassLabel : baseModel.packageClassLabel,
          quantity          : (baseModel.value && (baseModel.value!==true)) ? baseModel.value : 1,
          specialVars       : baseModel.specialVars ? baseModel.specialVars : {},
          price             : baseModel.price
        };
    };

    //Interfaces optimization
    optimizedInterfaces                      = automaticCalculationModel.automaticItems;
    automaticCalculationModel.automaticItems = optimizedInterfaces;

    var powerSupplyCalculator   = new this.powerSupplyCalculator(),
        keyCoversCalculator     = new this.keyCoversCalculator(),
        dataProvider            = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
        totalCurrentConsumption = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel").get("totalCurrentConsumption"),
        neededPowerSupplies     = powerSupplyCalculator.retrieveNecessaryPowerSupplies(totalCurrentConsumption, BticinoS4B.Instances.Models.ApplicationModel.get("powerSuppliesFromKit")),
        neededKeyCovers         = keyCoversCalculator.retrieveNecessaryKeyCovers(dataProvider.get("items").zonesItems, BticinoS4B.Instances.Models.ApplicationModel.get("keyCoversFromKit"));

    for (var z = neededPowerSupplies.length - 1; z >= 0; z--)
      automaticCalculationModel.automaticItems.push(neededPowerSupplies[z]);

    for (z = neededKeyCovers.length - 1; z >= 0; z--)
      automaticCalculationModel.automaticItems.push(neededKeyCovers[z]);

    dataProvider.addItems("automaticItems",    automaticCalculationModel.automaticItems);

    this.set("automaticCalculationModel",      automaticCalculationModel);
    BticinoS4B.Instances.Models.ApplicationModel.set("automaticProducts",         _.extend({}, this.get("automaticCalculationModel")));
    this.createConfiguration();
  };
  
  CalculationClass.powerSupplyCalculator     = Backbone.Model.extend({
    defaults : {
      idWizardChoice : 803
    },

    initialize    : function() {
      this.fetchPackages();
      window.BticinoS4B.eventAggregator.bind("currentDeliver:requested", this.deliverCurrent, this);
    },

/*    packagesRetrievedCallback: function(data) {
      var packages = data.packages;

      var valorizePackageWithProductAttributes = function(data) {
        data.products         = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
        data.products         = _.filter(data.products,function(product) {return product.mnemonic===1;});
        if (data.products.length>0)
          data = data.products[0];
        _.extend(packages[i], data);

        var secondaryProducts = _.filter(data.products,function(product) {return (product.mnemonic!==1);});

        packages[i].secondaryProducts=secondaryProducts;
      };

      //Converting specialVars to objects
      for (var i = packages.length - 1; i >= 0; i--)
      {
        if (packages[i].specialVars!=="")
          packages[i].specialVars = JSON.parse(packages[i].specialVars);

        BticinoS4B.Instances.Models.ApplicationModel.getProducts(packages[i].packageClassId, valorizePackageWithProductAttributes);
      }

      var powerSupplies   = _.filter(packages, function(iterablePackage)  {return iterablePackage.specialVars.currentConsumption<0;}),
          fetchedInterface= _.filter(packages, function(iterableInterface){return iterableInterface.specialVars.isAnInterface;})[0];

      this.set("fetchedPowerSupplies", powerSupplies);
      this.set("fetchedInterface",     fetchedInterface);
    },*/

    packagesRetrievedCallback: function(data) {
      var packages = data.packages;

      var valorizePackageWithProductAttributes = function(data) {
        data.products         = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
        data.products         = _.filter(data.products,function(product) {return product.mnemonic===1;});
        if (data.products.length>0)
          data = data.products[0];
        _.extend(packages[i], data);

        var secondaryProducts = _.filter(data.products,function(product) {return (product.mnemonic!==1);});

        packages[i].secondaryProducts=secondaryProducts;
      };

      //Converting specialVars to objects
      for (var i = packages.length - 1; i >= 0; i--)
      {
        if (packages[i].specialVars!=="")
          packages[i].specialVars = JSON.parse(packages[i].specialVars);

        BticinoS4B.Instances.Models.ApplicationModel.getProducts(packages[i].packageClassId, valorizePackageWithProductAttributes);
      }

      //Divide power supplies and interface
      var powerSupplies   = _.filter(packages, function(iterablePackage)  {return iterablePackage.specialVars.currentConsumption<0;}),
          fetchedInterface= _.filter(packages, function(iterableInterface){return iterableInterface.specialVars.isAnInterface;})[0];

      //Divide power supplies in standard PS and compact PS
      powerSupplies           = _.sortBy(powerSupplies, function(iterablePowerSupply){return Number(-iterablePowerSupply.specialVars.currentConsumption);});
      var compactPowerSupply  = powerSupplies[0],
          standardPowerSupply = powerSupplies[1];


      this.set("compactPowerSupply",   compactPowerSupply);
      this.set("standardPowerSupply",  standardPowerSupply);
      this.set("fetchedInterface",     fetchedInterface);
    },

    fetchPackages : function() {
      var that = this;
      BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(this.get("idWizardChoice"), function(data) {that.packagesRetrievedCallback.apply(that, [data]);});
    },

/*    calculateNecessaryPowerSupplies : function(totalCurrentConsumption, _powerSuppliesAlreadyOwned) {
      var powerSuppliesAlreadyOwned           =  [];

      if (_powerSuppliesAlreadyOwned)
        powerSuppliesAlreadyOwned = _powerSuppliesAlreadyOwned;

      var packagesToProvide                   =  [],
          interfacesToProvide                 =  [],
          fetchedPowerSupplies                =  this.get("fetchedPowerSupplies"),
          fetchedPowerSuppliesLength          =  fetchedPowerSupplies.length,
          fetchedInterface                    =  this.get("fetchedInterface"),
          originalCurrentConsumption          =  totalCurrentConsumption,
          numberOfOwnedPowerSuppliesProvided  =  0,
          i                                   =  0,
          j                                   =  0,
          ratio                               =  0,
          ratioCeil                           =  0,
          ratioFloor                          =  0,
          optimizedPackagesToProvide          =  [],
          currentProvidedByPowerSupplies      =  0,
          supplyProvidedByOwneds              =  _.reduce(powerSuppliesAlreadyOwned, function(memo, iterablePowerSupply){
                                              return memo + iterablePowerSupply.specialVars.currentConsumption;
                                            }, 0);
      //Order powerSupplies by current
      fetchedPowerSupplies = _.sortBy(fetchedPowerSupplies, function(iterablePowerSupply){return -iterablePowerSupply.specialVars.currentConsumption;});

      //Removing 600mA to adopting alghoritm calculation by the client
      if (powerSuppliesAlreadyOwned && powerSuppliesAlreadyOwned.length>0)
        fetchedPowerSupplies.splice(0,1);

      fetchedPowerSuppliesLength     =  fetchedPowerSupplies.length;

      for (i=0; i<fetchedPowerSuppliesLength; i++)
      {
        if (totalCurrentConsumption>=0)
        {

          //Is the current
          ratio = -totalCurrentConsumption / fetchedPowerSupplies[i].specialVars.currentConsumption;
          mod   = -totalCurrentConsumption % fetchedPowerSupplies[i].specialVars.currentConsumption;

          j          = Math.ceil(ratio);
          ratioCeil  = Math.ceil(ratio);
          ratioFloor = Math.floor(ratio);

          //Add calculated power supply
          for (j = 0; (totalCurrentConsumption>=0 && (packagesToProvide.length+interfacesToProvide.length)<9); j++)
          {

            //If the owned power supplies are enough to provide the correct current
            if (totalCurrentConsumption+(supplyProvidedByOwneds/powerSuppliesAlreadyOwned.length)<=0)
            {
              totalCurrentConsumption += supplyProvidedByOwneds/powerSuppliesAlreadyOwned.length;
              numberOfOwnedPowerSuppliesProvided++;

              if (packagesToProvide.length>0)
              {
                interfacesToProvide.push(fetchedInterface);

                if (fetchedInterface.specialVars.currentConsumption)
                  totalCurrentConsumption += fetchedInterface.specialVars.currentConsumption;
              }
            }
            else if ( ( (totalCurrentConsumption+supplyProvidedByOwneds) <= 0 ) && ( numberOfOwnedPowerSuppliesProvided < powerSuppliesAlreadyOwned.length) )
            {
              totalCurrentConsumption           += supplyProvidedByOwneds;
              numberOfOwnedPowerSuppliesProvided = powerSuppliesAlreadyOwned.length;

              if (powerSuppliesAlreadyOwned.length>1)
              {
                interfacesToProvide.push(fetchedInterface);

                if (fetchedInterface.specialVars.currentConsumption)
                  totalCurrentConsumption += fetchedInterface.specialVars.currentConsumption;
              }

              if (packagesToProvide.length>0)
              {
                interfacesToProvide.push(fetchedInterface);

                if (fetchedInterface.specialVars.currentConsumption)
                  totalCurrentConsumption += fetchedInterface.specialVars.currentConsumption;
              }
            }
            else
            {
              packagesToProvide.push(fetchedPowerSupplies[i]);
              if (packagesToProvide.length>1 || numberOfOwnedPowerSuppliesProvided>0)
              {
                interfacesToProvide.push(fetchedInterface);

                if (fetchedInterface.specialVars.currentConsumption)
                  totalCurrentConsumption += fetchedInterface.specialVars.currentConsumption;
              }

              //Remove used current
              totalCurrentConsumption += fetchedPowerSupplies[i].specialVars.currentConsumption;
            }
          }
        }
      }

      this.set("packagesToProvide", packagesToProvide.concat(interfacesToProvide));
      return packagesToProvide.concat(interfacesToProvide);
    },*/


    calculateNecessaryPowerSupplies : function(totalCurrentConsumption, _powerSuppliesAlreadyOwned) {
      var powerSuppliesAlreadyOwned           =  [];

      if (_powerSuppliesAlreadyOwned)
        powerSuppliesAlreadyOwned = _powerSuppliesAlreadyOwned;

      var packagesToProvide                   =  [],
          interfacesToProvide                 =  [],
          compactPowerSupply                  =  this.get("compactPowerSupply"),
          standardPowerSupply                 =  this.get("standardPowerSupply"),
          fetchedInterface                    =  this.get("fetchedInterface"),
          originalCurrentConsumption          =  totalCurrentConsumption,
          numberOfOwnedPowerSuppliesProvided  =  powerSuppliesAlreadyOwned.length,
          i                                   =  0,
          j                                   =  0,
          optimizedPackagesToProvide          =  [],
          currentProvidedByPowerSupplies      =  0,
          supplyProvidedByOwneds              =  _.reduce(powerSuppliesAlreadyOwned, function(memo, iterablePowerSupply){
                                                  return memo + iterablePowerSupply.specialVars.currentConsumption;
                                                }, 0);

      if(numberOfOwnedPowerSuppliesProvided>0)  //If there's at least one provided power supply
      {
        //If there's only one kit
        if (numberOfOwnedPowerSuppliesProvided===1)
        {
          if (totalCurrentConsumption>600)
          {
            if (totalCurrentConsumption>1200)
            {
              if (totalCurrentConsumption>1800)
              {
                while(totalCurrentConsumption>0 && ((packagesToProvide.length+numberOfOwnedPowerSuppliesProvided)<=9))
                {
                  if (packagesToProvide.length>0)
                  {
                    packagesToProvide.push(fetchedInterface);
                    totalCurrentConsumption += fetchedInterface.specialVars.currentConsumption;
                  }
                  packagesToProvide.push(standardPowerSupply);
                  totalCurrentConsumption += standardPowerSupply.specialVars.currentConsumption;
                }
              }
              else
              {
                packagesToProvide.push(fetchedInterface);
                packagesToProvide.push(standardPowerSupply);
                totalCurrentConsumption += fetchedInterface.specialVars.currentConsumption+standardPowerSupply.specialVars.currentConsumption;
              }
            }
            else
            {
              packagesToProvide.push(standardPowerSupply);
              totalCurrentConsumption += standardPowerSupply.specialVars.currentConsumption;
            }
          }
        }
        else //If there are two kits
        {
          if (totalCurrentConsumption>600)
          {
            if (totalCurrentConsumption>1200)
            {
              if (totalCurrentConsumption>1800)
              {
                while(totalCurrentConsumption>0 && ((packagesToProvide.length+numberOfOwnedPowerSuppliesProvided)<=9))
                {
                  if (packagesToProvide.length>0)
                  {
                    packagesToProvide.push(fetchedInterface);
                    totalCurrentConsumption += fetchedInterface.specialVars.currentConsumption;
                  }
                  packagesToProvide.push(standardPowerSupply);
                  totalCurrentConsumption += standardPowerSupply.specialVars.currentConsumption;
                }
              }
              else
              {
                packagesToProvide.push(fetchedInterface);
                packagesToProvide.push(standardPowerSupply);
                totalCurrentConsumption += fetchedInterface.specialVars.currentConsumption+standardPowerSupply.specialVars.currentConsumption;
              }
            }
            else
            {
              packagesToProvide.push(fetchedInterface);
              totalCurrentConsumption += fetchedInterface.specialVars.currentConsumption;
            }
          }
        }
      }
      else //If there's no provided power supply
      {
        while(totalCurrentConsumption>0 && packagesToProvide.length<9)
        {
          //If there's more than one
          if (packagesToProvide.length>0)
          {
            packagesToProvide.push(fetchedInterface);
            totalCurrentConsumption += fetchedInterface.specialVars.currentConsumption;
          }

          //If it's enough I add the compact one
          if (totalCurrentConsumption+compactPowerSupply.specialVars.currentConsumption<=0)
          {
            packagesToProvide.push(compactPowerSupply);
            totalCurrentConsumption += compactPowerSupply.specialVars.currentConsumption;
          }
          else //If it's not enough I add the standard one
          {
            packagesToProvide.push(standardPowerSupply);
            totalCurrentConsumption += standardPowerSupply.specialVars.currentConsumption;
          }
        }
      }
      this.set("packagesToProvide", packagesToProvide.concat(interfacesToProvide));
      return packagesToProvide.concat(interfacesToProvide);
    },

    retrieveNecessaryPowerSupplies  : function(totalCurrentConsumption, powerSuppliesAlreadyOwned) {
      var necessaryProducts  = this.calculateNecessaryPowerSupplies(totalCurrentConsumption, powerSuppliesAlreadyOwned),
          productsToReturn   = [];

      necessaryProducts      = _.groupBy(necessaryProducts, function(iterableProduct){ return iterableProduct.packageClassId; });

      for (var key in necessaryProducts)
      {
        productsToReturn.push(_.extend(necessaryProducts[key][0], {quantity : necessaryProducts[key].length, validFor : []}));
      }

      for (var i = 0, length = productsToReturn.length; i < length; i++) {
        productsToReturn[i].groupId = productsToReturn[i].specialVars.groupId;
      }

      return productsToReturn;
    },

    deliverCurrent  : function()  {
      var collection                  = this.get("packagesToProvide") ? this.get("packagesToProvide") : [], collectionLength = collection.length;
      var consumptionIndicatorModel   = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
      var mustDeliverExtraConsumption = false;
      var consumption                 = 0;
      var i                           = 0;

      //Delivering regular consumptions
      for (i=0; i<collectionLength; i++)
        consumption+=collection[i].specialVars.currentConsumption*collection[i].quantity;

      if (consumption<0)
        consumptionIndicatorModel.addSupplyCurrent(consumption);
      else
        consumptionIndicatorModel.addCurrentConsumption(consumption);
    }
  });

  CalculationClass.keyCoversCalculator       = Backbone.Model.extend({

    defaults : {
      idWizardChoices : [847,848, 851]
    },

    initialize    : function() {
      this.fetchPackages();
    },

    fetchPackages : function() {
      var that = this,
          callback = function(data) {that.packagesRetrievedCallback.apply(that, [data]);};
      this.set("fetchedKeyCovers", []);

      for (var i = 0, length = this.get("idWizardChoices").length; i < length; i++) {
        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(this.get("idWizardChoices")[i], callback);
      }
    },

    packagesRetrievedCallback : function(data) {
      var packages        = data.packages,
          fetchedKeyCovers= this.get("fetchedKeyCovers"),
          length = 0;

      var valorizePackageWithProductAttributes = function(data) {
        data.products         = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
        data.products         = _.filter(data.products,function(product) {return product.mnemonic===1;});
        if (data.products.length>0)
          data = data.products[0];
        _.extend(packages[i], data);

        var secondaryProducts = _.filter(data.products,function(product) {return (product.mnemonic!==1);});

        packages[i].secondaryProducts=secondaryProducts;
      };

      //Converting specialVars to objects
      for (var i = packages.length - 1; i >= 0; i--)
      {
        if (packages[i].specialVars!=="")
          packages[i].specialVars = JSON.parse(packages[i].specialVars);

        BticinoS4B.Instances.Models.ApplicationModel.getProducts(packages[i].packageClassId, valorizePackageWithProductAttributes);
      }

      for (i = 0, length = packages.length; i < length; i++) {
        fetchedKeyCovers.push(packages[i]);
      }
      this.set("fetchedKeyCovers", fetchedKeyCovers);
    },

    retrieveNecessaryKeyCovers  : function(zonesItems, keyCoversAlreadyOwned) {
      var i, j, l,
          ilength, jlength, llength,
          requiredKeyCovers = [],
          itemToAdd         = {},
          keyCoversToReturn = [],
          fetchedKeyCovers  = this.get("fetchedKeyCovers"),
          coverToMerge;

      if (zonesItems)
      {
        //Retrieing all required key covers
        for (i = 0, ilength = zonesItems.length; i < ilength; i++)
        {
          if (zonesItems[i].items)
            for (j = 0, jlength = zonesItems[i].items.length; j < jlength; j++)
            {
              if (zonesItems[i].items[j].requiredKeyCovers)
                for (l = 0, llength = zonesItems[i].items[j].requiredKeyCovers.length; l < llength; l++)
                {
                  itemToAdd = {};
                  itemToAdd.quantity = zonesItems[i].items[j].requiredKeyCovers[l].quantity*zonesItems[i].items[j].quantity;
                  itemToAdd.type     = zonesItems[i].items[j].requiredKeyCovers[l].type;
                  requiredKeyCovers.push(itemToAdd);
                }
            }
        }
        requiredKeyCovers = _.groupBy(requiredKeyCovers, function(keyCover){return keyCover.type;});

        for (var keyCoverType in requiredKeyCovers)
        {
          itemToAdd = {
            quantity : 0,
            type : keyCoverType
          };

          for(i=0; i<requiredKeyCovers[keyCoverType].length; i++)
            itemToAdd.quantity += requiredKeyCovers[keyCoverType][i].quantity;

          keyCoversToReturn.push(itemToAdd);
        }

        var retrieveCorrectCoverData = function(iterableCover){return iterableCover.specialVars.keyCoverType===objectToAnalize.type;};

        //Valorize covers to return with proper attributes
        for (i=0; i<keyCoversToReturn.length; i++)
        {
          objectToAnalize      = keyCoversToReturn[i];
          coverToMerge         = _.filter(fetchedKeyCovers, retrieveCorrectCoverData)[0];
          keyCoversToReturn[i] = _.extend(keyCoversToReturn[i], coverToMerge);
        }
      }

      return keyCoversToReturn;
    }
  });



  CalculationClass.createConfiguration       =  function() {
    //Counters
    var i, j, l, g, k=1, counter=0, productToAdd, productQuantity, validitiesLength;
    var sobstitutionMatrix = [];
    var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider");

    //Model to send
    var modelToSend = {
      token : window.BticinoS4B.token,
      items : []
    };

    //Submodel
    var externalItems         = dataProvider.get("items").externalItems   ? dataProvider.get("items").externalItems   : null,
        externalItemsLength   = externalItems   ? externalItems.length   : 0;

    var zones                 = dataProvider.get("items").zonesItems      ? dataProvider.get("items").zonesItems      : null,
        zonesLength           = zones           ? zones.length           : 0;

    var automaticItems        = dataProvider.get("items").automaticItems  ? dataProvider.get("items").automaticItems  : null,
        automaticItemsLength  = automaticItems ? automaticItems.length   : 0;

    var optionalPackages      = BticinoS4B.Instances.Models.ApplicationModel.get("optionalPackages"),
        optionalPackagesLength= optionalPackages.length;

    var plainProducts   = [];
    modelToSend         = [];

    //Adding external items to plain products array
    for (i=0; i<externalItemsLength; i++)
    {
      productToAdd           = _.extend({}, externalItems[i]);
      if (productToAdd.packageClassId!=="2002")
      {
        productQuantity        = productToAdd.quantity;
        productToAdd.zone      = 0;
        productToAdd.aux       = "";

        for (j=0;j<productQuantity; j++) {
          productToAdd.newProgNumber = k;
          plainProducts.push(_.extend({attachedProducts : []}, productToAdd));
          k++;
        }
      }
    }

    //Adding zone items to plain products array
    for (i=0; i<zonesLength; i++)
    {
      var zoneLength = zones[i].items.length;

      for (j=0; j<zoneLength; j++)
      {
        if (zones[i].items[j].packageClassId)
        {
          productToAdd           = _.extend({}, zones[i].items[j]);
          productQuantity        = productToAdd.quantity;
          //delete productToAdd.quantity;

          productToAdd.zone      = productToAdd.Zn ? productToAdd.Zn : zones[i].number;
          productToAdd.aux       = "";

          for (l=0;l<productQuantity; l++)
          {
            productToAdd.newProgNumber = k;
            plainProducts.push(_.extend({attachedProducts : []}, productToAdd));
            k++;
          }
        }
      }
    }

    //Adding optional items to plain products array
    for (i=0; i<optionalPackagesLength; i++)
    {
      var packageToAdd           = _.extend({}, optionalPackages[i]);
      var packageProducts        = packageToAdd.get("products").packagesByOptionalPackageId;
      var packageProductsLength  = packageProducts.length;

      for (l=0; l<packageProductsLength; l++)
      {
        productToAdd                = _.extend(packageProducts[l]);
        productQuantity             = 0;
        var productPackageClassId   = "";

        if(productToAdd.attributes)
        {
          productQuantity               = productToAdd.get("value");
          productPackageClassId         = productToAdd.get("packageClassId");
        }
        else
        {
          productQuantity               = productToAdd.value;
          productPackageClassId         = productToAdd.packageClassId;
        }
        var zoneValue = 0;

        productToAdd = {
          zone            : zoneValue,
          aux             : "",
          packageClassId  : productPackageClassId
        };

        for (j=0;j<productQuantity; j++)
        {
          productToAdd.newProgNumber = k;
          plainProducts.push(_.extend({}, productToAdd));
          k++;
        }
      }
    }


    //Adding autocalculated items
    var iterator = function(item){return item.progNumber;};
    for (i=0; i<automaticItemsLength; i++) {
      validitiesLength       = automaticItems[i].attachedProducts ? automaticItems[i].attachedProducts.length : 0;
      productToAdd           = _.extend({}, automaticItems[i]);
      productQuantity        = productToAdd.quantity;
      //delete productToAdd.quantity;

      productToAdd.zone      = 0;
      productToAdd.aux       = "";

      for (l=0;l<productQuantity; l++)
      {
        productToAdd.newProgNumber = k;
        plainProducts.push(_.extend({}, productToAdd));
        k++;
      }
    }

    //Adding autocalculated items with validities
    for (i=0; i<plainProducts.length; i++)
    {
      if (plainProducts[i].attachedProducts)
      {
        plainProducts[i].slot = [];
        for (j=0; j<plainProducts[i].attachedProducts.length; j++)
        {
          plainProducts[i].slot.push({
            idLink : plainProducts[i].attachedProducts[j].progNumber
          });
        }
      }
    }

    /*Assigning values for N on plainProducts*/

    var plainProductsWithGroupIds         = _.groupBy(plainProducts, function(product){if (product.groupId) return product.groupId; else return false;}),
        zoneIds                           = _.uniq(_.map(plainProducts, function(el) {return el.zone;})),
        productClassIds                   = _.uniq(_.map(plainProducts, function(el) {return el.packageClassId;})),
        zoneIdsLength                     = zoneIds.length,
        productClassIdsLength             = productClassIds.length,
        plainProductsWithGroupIdsLength   = 0,
        nCounter                          = 1;

    for (var product in plainProductsWithGroupIds)
    {
      if (product==="-1")
        nCounter = 0;
      else
        nCounter = 1;

      plainProductsWithGroupIdsLength   = plainProductsWithGroupIds[product].length;
      for (j=0; j<plainProductsWithGroupIdsLength; j++)
      {
        if  ( (!plainProductsWithGroupIds[product][j].validFor) || ((plainProductsWithGroupIds[product][j].validFor) && (plainProductsWithGroupIds[product][j].validFor.length===0)) )
        {
          plainProductsWithGroupIds[product][j].N = nCounter;
          plainProductsWithGroupIds[product][j].Zn= plainProductsWithGroupIds[product][j].zone;
          if (product!=="-1")
            nCounter++;
        }
      }
    }

    for (product in plainProductsWithGroupIds)
    {
      plainProductsWithGroupIdsLength   = plainProductsWithGroupIds[product].length;

      /*Assigning values for N on attached products*/
      for(i=0; i<plainProductsWithGroupIdsLength; i++)
      {
        if ((plainProductsWithGroupIds[product][i].attachedProducts)&&(plainProductsWithGroupIds[product][i].attachedProducts.length>0))
        {
          for (j=0; j<plainProductsWithGroupIds[product][i].attachedProducts.length; j++)
          {
            for (var prod in plainProductsWithGroupIds)
            {
              for (l=0; l<plainProductsWithGroupIds[prod].length; l++)
                if (plainProductsWithGroupIds[prod][l].progNumber === plainProductsWithGroupIds[product][i].attachedProducts[j].idLink)
                {
                  plainProductsWithGroupIds[product][i].attachedProducts[j].N = plainProductsWithGroupIds[prod][l].N;
                  plainProductsWithGroupIds[product][i].attachedProducts[j].Z = 0; //Required for automation
                  plainProductsWithGroupIds[product][i].attachedProducts[j].idLink = plainProductsWithGroupIds[prod][l].newProgNumber;
                  break;
                }
            }
          }
        }
      }
      var finalProductToAdd,
          objectToAdd;
      for(i=0; i<plainProductsWithGroupIdsLength; i++)
      {
        if (plainProductsWithGroupIds[product][i].packageClassId)
        {
          objectToAdd = {
            progNumber      : plainProductsWithGroupIds[product][i].newProgNumber,
            packageClassId  : plainProductsWithGroupIds[product][i].packageClassId,
            slot            : []
          };

          objectToAdd.Z = 0; //Required for automation
          objectToAdd.Zn= plainProductsWithGroupIds[product][i].Zn;

          if (plainProductsWithGroupIds[product][i].N!==undefined)
            objectToAdd.N = plainProductsWithGroupIds[product][i].N;

          if (plainProductsWithGroupIds[product][i].decade0!==undefined)
            objectToAdd.decade0 = plainProductsWithGroupIds[product][i].decade0;
          else
            objectToAdd.decade0 = 0;

          if (plainProductsWithGroupIds[product][i].slotsnumber!==undefined)
            objectToAdd.slotsnumber = plainProductsWithGroupIds[product][i].slotsnumber;

          if (plainProductsWithGroupIds[product][i].loadType!==undefined)
            objectToAdd.loadType = plainProductsWithGroupIds[product][i].loadType;
          else
            objectToAdd.loadType = "";

          if (plainProductsWithGroupIds[product][i].attachedProducts)
          {
            for (j=0; j<plainProductsWithGroupIds[product][i].attachedProducts.length; j++)
            {
              for (l=0; l<plainProductsWithGroupIds[product][i].attachedProducts[j].Slots; l++)
              {
                finalProductToAdd = {
                  Z      : objectToAdd.Z = 0, //Required for automation
                  Zn     : objectToAdd.Zn = objectToAdd.Zn,
                  N      : plainProductsWithGroupIds[product][i].attachedProducts[j].N ? plainProductsWithGroupIds[product][i].attachedProducts[j].N : 0,
                  idLink : plainProductsWithGroupIds[product][i].attachedProducts[j].idLink ? plainProductsWithGroupIds[product][i].attachedProducts[j].idLink : 0,
                  slot   : []
                };

                objectToAdd.slot.push(_.extend({}, finalProductToAdd));
              }
            }
          }

          modelToSend.push(objectToAdd);
        }
      }
    }

    var configuration;
    var getAddedProductDetails  = function(packageDetails){
      configuration.itemsConfiguratorAdded[i] = _.extend(configuration.itemsConfiguratorAdded[i], packageDetails);
      BticinoS4B.Instances.Models.ApplicationModel.getProducts(configuration.itemsConfiguratorAdded[i].packageClassId, function(productDetails) {
        productDetails.products                 = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(productDetails.products);
        configuration.itemsConfiguratorAdded[i] = _.extend(configuration.itemsConfiguratorAdded[i], productDetails.products[0]);

        if (configuration.itemsConfiguratorAdded[i].Qta)
        {
          configuration.itemsConfiguratorAdded[i].quantity = Number(configuration.itemsConfiguratorAdded[i].Qta, 10);
          delete configuration.itemsConfiguratorAdded[i].Qta;
        }
      });
    };

    //Used to re-associate items
    var getPackageDetails       = function(data) {
      configuration     = data.d;
      var itemsLength   = data.d.items ? data.d.items.length : 0;

      for(i=0; i<itemsLength; i++)
      {
        configuration.items[i].progNumber = Number(configuration.items[i].progNumber, 10);
      }
      configuration.items = _.sortBy(configuration.items, function(element){ return element.progNumber; });
      modelToSend         = _.sortBy(modelToSend, function(element){ element.Z = element.Zn; return element.progNumber; });

      for(i=0; i<itemsLength; i++)
      {
        _.extend(modelToSend[i], configuration.items[i]);
      }
      configuration.items = modelToSend;

      var retrievePackageClass = function(counter) {
        if (configuration.items[counter].packageClassId)
          BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(configuration.items[counter].packageClassId, function(result) {
            configuration.items[counter] = _.extend(configuration.items[counter], result);
          });
      };

      for(i=0; i<itemsLength; i++)
        retrievePackageClass(i);

      if (configuration.itemsConfiguratorAdded)
        for(i=0; i<configuration.itemsConfiguratorAdded.length; i++)
          BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(configuration.itemsConfiguratorAdded[i].packageClassId, getAddedProductDetails);

      /*Removing object from kit*/
      var retrieveFinalQuantity    = function(item) {
        var configurationProductsFromKit = BticinoS4B.Instances.Models.ApplicationModel.get("configurationProductsFromKit"),
            productsFromKit              = _.filter(configurationProductsFromKit, function(iterableItemFromKit){return iterableItemFromKit.packageClassId===item.packageClassId;});

        if (productsFromKit.length>0)
          item.quantity = item.quantity - productsFromKit[0].quantity;

        return item;
      };

      if (configuration.itemsConfiguratorAdded)
        for (i = configuration.itemsConfiguratorAdded.length - 1; i >= 0; i--) {
          configuration.itemsConfiguratorAdded[i] = retrieveFinalQuantity(configuration.itemsConfiguratorAdded[i]);
        }

      BticinoS4B.Instances.Models.ApplicationModel.set("configurationModel", configuration);
      var configurationModel          = BticinoS4B.Instances.Models.ApplicationModel.get("configurationModel").items;
      var configurationModelLength    = configurationModel.length;
      var completeConfigurationModel  = new Backbone.Model();

      for (i=0; i<configurationModelLength; i++)
      {
        if(configurationModel[i].slot)
        {
          if(configurationModel[i].slot.length>0)
          {
            for(j=0; j<configurationModel[i].slot.length; j++)
            {
              for(l=0; l<configurationModel.length; l++)
              {
                if (configurationModel[l].progNumber===configurationModel[i].slot[j].idLink)
                {
                  configurationModel[i].slot[j] = _.extend(configurationModel[i].slot[j], configurationModel[l]);
                  break;
                }
              }
            }
          }
        }
      }
      var outOfZoneArticles        = _.filter(configurationModel,      function(element) {return (!element.Z);});
      var zones                    = _.difference(configurationModel, outOfZoneArticles);
      var zoneNumbers              = _.sortBy(_.uniq(_.map(zones,     function(element) {return element.Z;})), function(element){return element;});

      var iterator = function(element) {
        return (element.Z===zoneNumbers[i]);
      };

      for(i=0; i<zoneNumbers.length; i++)
      {
        zoneNumbers[i] = {number : zoneNumbers[i], items : _.filter(zones, iterator)};
      }
      completeConfigurationModel.set("outOfZoneArticles", outOfZoneArticles);
      completeConfigurationModel.set("zoneArticles", zoneNumbers);
      BticinoS4B.Instances.Models.ApplicationModel.set("getZoneName", function(zoneNumber){
        var name;

        switch(zoneNumber)
        {
        case "-6_1":
          name = $.i18n._("IDS_WAM8_30");
          break;
        case "-6_2":
          name = $.i18n._("IDS_WAM8_31");
          break;
        case "-6_3":
          name = $.i18n._("IDS_WAM8_28");
          break;
        case -6:
          name = $.i18n._("IDS_W3_9002");
          break;
        case -5:
          name = $.i18n._("IDS_W3_9010");
          break;
        case -4:
          name = $.i18n._("IDS_W3_9011");
          break;
        case -3:
          name = $.i18n._("IDS_W3_9013");
          break;
        case -2:
          name = $.i18n._("IDS_W3_9014");
          break;
        case -1:
          name = $.i18n._("IDS_WAM8_25_2");
          break;
        case 0:
          name = $.i18n._("IDS_W1_9111");
          break;
        default:
          name = $.i18n._("IDS_WTR1001_9001") + " " + zoneNumber;
        }

        return name;
      });
      
      BticinoS4B.solution.energyManagement.completeConfiguration = completeConfigurationModel;
      BticinoS4B.Instances.Models.ApplicationModel.set("completeConfiguration", completeConfigurationModel);
    };

    var lastModelSent = BticinoS4B.Instances.Models.ApplicationModel.get("lastModelSentToConfigurationService");

    objectToSend      = JSON.stringify({
          catalogueId: BticinoS4B.Instances.Models.ApplicationModel.get("catalogId"),
          token      : window.BticinoS4B.token,
          items      : modelToSend,
          string: {
            IDS_W1_9120: $.i18n._("IDS_W1_9120"),
            IDS_W1_9121: $.i18n._("IDS_W1_9121"),
            IDS_W1_9122: $.i18n._("IDS_W1_9122"),
            IDS_W1_9123: $.i18n._("IDS_W1_9123"),
            IDS_W1_9124: $.i18n._("IDS_W1_9124"),
            IDS_W1_9125: $.i18n._("IDS_W1_9125"),
            IDS_W1_9126: $.i18n._("IDS_W1_9126")
          }
    });

    if (lastModelSent!==objectToSend)
    {
      BticinoS4B.Instances.Models.ApplicationModel.set("lastModelSentToConfigurationService", objectToSend);
      $.ajax({
        type        : "POST",
        datatype    : "json",
        contentType : "application/json",
        async       : false,
        url         : "/btreport/JSonInterface.asmx/JSonMakeConfiguratorAUTOM",
        data        : objectToSend,
        success     : function(data){
          BticinoS4B.Instances.Models.ApplicationModel.set("lastConfiguration", JSON.stringify(data));
          getPackageDetails(data);
        }
      });
    }
    else
      getPackageDetails(JSON.parse(BticinoS4B.Instances.Models.ApplicationModel.get("lastConfiguration")));

    dataProvider.addItems("configurationItems", BticinoS4B.Instances.Models.ApplicationModel.get("configurationModel").itemsConfiguratorAdded);
  };

  CalculationClass.retrieveModels            =  function() {
    var currentModel,
        modelToSave = {},
        i=0, j=0;

    CalculationClass.resetValues();

    //Requesting model delivery
    window.BticinoS4B.eventAggregator.trigger("modelDeliver:request",this);

    /* Setting systemId */
    modelToSave.systemId                       = '#21';
    modelToSave.inserted                       = BticinoS4B.solution.energyManagement.inserted;
    
    if (BticinoS4B.Instances.Models.ApplicationModel.get('kitCode')) {
      modelToSave.kitCode = BticinoS4B.Instances.Models.ApplicationModel.get('kitCode');
    }

    /*Preparing for saving*/
    modelToSave.accessoryLine                       = {};

    /*Retrieving accessory line datas*/
    if (BticinoS4B.Instances.Models.ApplicationModel.get && BticinoS4B.Instances.Models.ApplicationModel.get("choosenLine"))      modelToSave.accessoryLine.line   = BticinoS4B.Instances.Models.ApplicationModel.get("choosenLine").id;
    if (BticinoS4B.Instances.Models.ApplicationModel.get && BticinoS4B.Instances.Models.ApplicationModel.get("choosenColor"))     modelToSave.accessoryLine.color  = BticinoS4B.Instances.Models.ApplicationModel.get("choosenColor").id;

    /*Retrieving power supply and system selection datas*/
    if (BticinoS4B.solution.energyManagement.automationSystemSelection)
    {
      currentModel                                = BticinoS4B.solution.energyManagement.automationSystemSelection;
      var automationSystemSelection = {
        inhibited       : currentModel.attributes.inhibited,
        automationSystem: {
          lightsAndRollingShutters : {
            enabled       : currentModel.attributes.automationSystem.lightsAndRollingShutters.enabled,
            memoryModule  : {
              value           : currentModel.attributes.automationSystem.lightsAndRollingShutters.memoryModule.value,
              packageCLassId  : currentModel.attributes.automationSystem.lightsAndRollingShutters.memoryModule.packageClassId
            }
          },
          zigbeeRadio : {
            enabled   : currentModel.attributes.automationSystem.zigbeeRadio.enabled,
            partOfKit   : currentModel.attributes.automationSystem.zigbeeRadio.partOfKit,
            zigbeeInterface : {
              value : currentModel.attributes.automationSystem.zigbeeRadio.zigbeeInterface.value
            }
          }
        },
        energyManagement : {
          loadsControl      : {
            enabled : currentModel.attributes.energyManagement.loadsControl.enabled,
            partOfKit : currentModel.attributes.energyManagement.loadsControl.partOfKit
          },
          consumptionVisualization : {
            enabled           : currentModel.attributes.energyManagement.consumptionVisualization.enabled,
            energyDataLogger  :  {
              value             : currentModel.attributes.energyManagement.consumptionVisualization.energyDataLogger.value,
              packageClassId    : currentModel.attributes.energyManagement.consumptionVisualization.energyDataLogger.packageClassId
            }
          },
          partOfKit : currentModel.attributes.energyManagement.partOfKit
        },
        traditional : currentModel.attributes.traditional
      };
      modelToSave.automationSystemSelection = automationSystemSelection;
    }

    /**
     * Kits
     */
    if (BticinoS4B.solution.energyManagement.kits && BticinoS4B.solution.energyManagement.kits.get)
    {
      modelToSave.kitsModel = { collection : []};
      currentModel = BticinoS4B.solution.energyManagement.kits.get("fetchedKits") ? BticinoS4B.solution.energyManagement.kits.get("fetchedKits") : [];
      for (i=0; i<currentModel.length; i++)
      {
        if (currentModel[i].get("added"))
        {
          modelToSave.kitsModel.collection.push({packageClassId    : currentModel[i].get("packageClassId")});
        }
      }
    }

    //////////////////////////////////////////////////////
    //Automation zone/////////////////////////////////////
    //////////////////////////////////////////////////////
    //modelToSave.automation = {};

    /**
     * LightPoints
     */
    /*if (BticinoS4B.solution.energyManagement.lightPoints && BticinoS4B.solution.energyManagement.lightPoints.get)
    {
      modelToSave.automation.lightPointsModel = { collection : []};
      currentModel = BticinoS4B.solution.energyManagement.lightPoints.get("collection").models ? BticinoS4B.solution.energyManagement.lightPoints.get("collection").models : [];
      for (i=0; i<currentModel.length; i++)
      {
        modelToSave.automation.lightPointsModel.collection.push({
          number       : currentModel[i].get("number")        ? currentModel[i].get("number")                       : undefined,
          choosenGroup : currentModel[i].get("choosenGroup")  ? currentModel[i].get("choosenGroup")                 : undefined,
          masterPackage: currentModel[i].get("masterPackage") ? currentModel[i].get("masterPackage").packageClassId : undefined,
          slavePackage : currentModel[i].get("slavePackage")  ? currentModel[i].get("slavePackage").packageClassId  : undefined,
          typeOfLight  : currentModel[i].get("typeOfLight")   ? currentModel[i].get("typeOfLight")                  : undefined,
          partOfKit    : currentModel[i].get("partOfKit")     ? currentModel[i].get("partOfKit")                    : undefined,
          value        : currentModel[i].get("value")         ? currentModel[i].get("value")                        : undefined,
          isSlave      : currentModel[i].get("isSlave")       ? currentModel[i].get("isSlave")                      : undefined,
          description  : currentModel[i].get("description")
        });
      }
    }
    */
    /*
     * Engines
     */
    /*if (BticinoS4B.solution.energyManagement.engines && BticinoS4B.solution.energyManagement.engines.get)
    {
      modelToSave.automation.enginesModel = { collection : []};
      currentModel = BticinoS4B.solution.energyManagement.engines.get("collection").models ? BticinoS4B.solution.energyManagement.engines.get("collection").models : [];
      for (i=0; i<currentModel.length; i++)
      {
        modelToSave.automation.enginesModel.collection.push({
          number       : currentModel[i].get("number")        ? currentModel[i].get("number")                       : undefined,
          choosenGroup : currentModel[i].get("choosenGroup")  ? currentModel[i].get("choosenGroup")                 : undefined,
          masterPackage: currentModel[i].get("masterPackage") ? currentModel[i].get("masterPackage").packageClassId : undefined,
          slavePackage : currentModel[i].get("slavePackage")  ? currentModel[i].get("slavePackage").packageClassId  : undefined,
          typeOfEngine : currentModel[i].get("typeOfEngine")  ? currentModel[i].get("typeOfEngine")                 : undefined,
          partOfKit    : currentModel[i].get("partOfKit")     ? currentModel[i].get("partOfKit")                    : undefined,
          value        : currentModel[i].get("value")         ? currentModel[i].get("value")                        : undefined,
          isSlave      : currentModel[i].get("isSlave")       ? currentModel[i].get("isSlave")                      : undefined,
          description  : currentModel[i].get("description")
        });
      }
    }
    */
    /*
     * Command Points
     */
    /*if (BticinoS4B.solution.energyManagement.commandPoints && BticinoS4B.solution.energyManagement.commandPoints.get)
    {
      modelToSave.automation.commandPointsModel = { collection : []};
      currentModel = BticinoS4B.solution.energyManagement.commandPoints.get("collection").models ? BticinoS4B.solution.energyManagement.commandPoints.get("collection").models : [];
      for (i=0; i<currentModel.length; i++)
      {
        modelToSave.automation.commandPointsModel.collection.push({
          number                  : currentModel[i].get("number")                  ? currentModel[i].get("number")                  : undefined,
          choosenGroup            : currentModel[i].get("choosenGroup")            ? currentModel[i].get("choosenGroup")            : undefined,
          packageClassId          : currentModel[i].get("packageClassId")          ? currentModel[i].get("packageClassId")          : undefined,
          accessoryPackageClassId : currentModel[i].get("accessory")               ? currentModel[i].get("accessory").packageClassId: undefined,
          wizardChoiceCode        : currentModel[i].get("wizardChoiceCode")        ? currentModel[i].get("wizardChoiceCode")        : undefined,
          partOfKit               : currentModel[i].get("partOfKit")               ? currentModel[i].get("partOfKit")               : undefined,
          value                   : currentModel[i].get("value")                   ? currentModel[i].get("value")                   : undefined
        });
      }
    }
    */
    //////////////////////////////////////////////////////
    //Integration and control/////////////////////////////
    //////////////////////////////////////////////////////
    modelToSave.integrationAndControl = {};

    /*
     * Touchscreens
     */
    if (BticinoS4B.solution.energyManagement.advancedCommands && BticinoS4B.solution.energyManagement.advancedCommands.get)
    {
      modelToSave.integrationAndControl.advancedCommandsModel = { collection : []};
      currentModel = BticinoS4B.solution.energyManagement.advancedCommands.get("collection").models ? BticinoS4B.solution.energyManagement.advancedCommands.get("collection").models : [];
      for (i=0; i<currentModel.length; i++)
      {
        modelToSave.integrationAndControl.advancedCommandsModel.collection.push({
          number          : currentModel[i].get("number")        ? currentModel[i].get("number")        : undefined,
          packageClassId  : currentModel[i].get("packageClassId")? currentModel[i].get("packageClassId"): undefined,
          value           : currentModel[i].get("value")         ? currentModel[i].get("value")         : undefined,
          partOfKit       : currentModel[i].get("partOfKit")     ? currentModel[i].get("partOfKit")     : undefined
        });
      }
    }

    /*
     * Scarios commands
     */
    if (BticinoS4B.solution.energyManagement.scenariosCommands && BticinoS4B.solution.energyManagement.scenariosCommands.get)
    {
      modelToSave.integrationAndControl.scenariosCommandsModel = { collection : []};
      currentModel = BticinoS4B.solution.energyManagement.scenariosCommands.get("collection").models ? BticinoS4B.solution.energyManagement.scenariosCommands.get("collection").models : [];
      for (i=0; i<currentModel.length; i++)
      {
        modelToSave.integrationAndControl.scenariosCommandsModel.collection.push({
          number                   : currentModel[i].get("number")        ? currentModel[i].get("number")        : undefined,
          packageClassId           : currentModel[i].get("packageClassId")? currentModel[i].get("packageClassId"): undefined,
          accessoryPackageClassId  : currentModel[i].get("accessory")     ? currentModel[i].get("accessory").packageClassId: undefined,
          value                    : currentModel[i].get("value")         ? currentModel[i].get("value")         : undefined,
          partOfKit                : currentModel[i].get("partOfKit")     ? currentModel[i].get("partOfKit")     : undefined
        });
      }
    }

    /*
     * Integration devices
     */
    if (BticinoS4B.solution.energyManagement.integrationDevices && BticinoS4B.solution.energyManagement.integrationDevices.get)
    {
      currentModel = BticinoS4B.solution.energyManagement.integrationDevices;
      modelToSave.integrationAndControl.integrationDevicesModel = {
        scenarioDinModule  : currentModel.get("scenarioDinModuleModel").get("enabled"),
        scenarioDinQuantity: currentModel.get("scenarioDinModuleModel").get("value"),
        scenarioProgrammer : currentModel.get("scenarioProgrammerModel").get("enabled"),
        webServer          : currentModel.get("webServerModel").get("enabled"),
        software           : currentModel.get("softwareModel").get("enabled")
      };
    }

    //////////////////////////////////////////////////////
    //Energy Management zone//////////////////////////////
    //////////////////////////////////////////////////////
    modelToSave.energyManagement = {};

    /*
     * Gauges and interfaces
     */
    if (BticinoS4B.solution.energyManagement.gaugesAndInterfaces && BticinoS4B.solution.energyManagement.gaugesAndInterfaces.get)
    {
      modelToSave.energyManagement.gaugesAndInterfacesModel = { collection : []};
      currentModel = BticinoS4B.solution.energyManagement.gaugesAndInterfaces.get("collection").models ? BticinoS4B.solution.energyManagement.gaugesAndInterfaces.get("collection").models : [];
      for (i=0; i<currentModel.length; i++)
      {
        modelToSave.energyManagement.gaugesAndInterfacesModel.collection.push({
          number          : currentModel[i].get("number")        ? currentModel[i].get("number")        : undefined,
          packageClassId  : currentModel[i].get("packageClassId")? currentModel[i].get("packageClassId"): undefined,
          description     : currentModel[i].get("description")   ? currentModel[i].get("description")   : undefined,
          partOfKit       : currentModel[i].get("partOfKit")     ? currentModel[i].get("partOfKit")     : undefined
        });
      }
    }

    /*
     * Controlled loads
     */
    if (BticinoS4B.solution.energyManagement.controlledLoads && BticinoS4B.solution.energyManagement.controlledLoads.get)
    {
      modelToSave.energyManagement.controlledLoadsModel = { collection : []};
      currentModel = BticinoS4B.solution.energyManagement.controlledLoads.get("collection").models ? BticinoS4B.solution.energyManagement.controlledLoads.get("collection").models : [];
      for (i=0; i<currentModel.length; i++)
      {
        modelToSave.energyManagement.controlledLoadsModel.collection.push({
          packageClassId  : currentModel[i].get("packageClassId")? currentModel[i].get("packageClassId"): undefined,
          priorityValue   : currentModel[i].get("priorityValue") ? currentModel[i].get("priorityValue") : undefined,
          description     : currentModel[i].get("description")   ? currentModel[i].get("description")   : undefined,
          partOfKit       : currentModel[i].get("partOfKit")     ? currentModel[i].get("partOfKit")     : undefined
        });
      }
    }

    /*
     * Commands
     */
    if (BticinoS4B.solution.energyManagement.commands && BticinoS4B.solution.energyManagement.commands.get)
    {
      modelToSave.energyManagement.commandsModel = { collection : []};
      currentModel = BticinoS4B.solution.energyManagement.commands.get("collection").models ? BticinoS4B.solution.energyManagement.commands.get("collection").models : [];
      for (i=0; i<currentModel.length; i++)
      {
        modelToSave.energyManagement.commandsModel.collection.push({
          number          : currentModel[i].get("number")        ? currentModel[i].get("number")        : undefined,
          packageClassId  : currentModel[i].get("packageClassId")? currentModel[i].get("packageClassId"): undefined,
          value           : currentModel[i].get("value")         ? currentModel[i].get("value")         : undefined,
          partOfKit       : currentModel[i].get("partOfKit")     ? currentModel[i].get("partOfKit")     : undefined
        });
      }
    }

    //////////////////////////////////////////////////////
    //Traditional zone////////////////////////////////////
    //////////////////////////////////////////////////////
    modelToSave.traditional = {};

    /*
     * Traditionals
     */
    if (BticinoS4B.solution.energyManagement.traditional && BticinoS4B.solution.energyManagement.traditional.get)
    {
      modelToSave.traditional.traditionalModel = { collection : []};
      currentModel = BticinoS4B.solution.energyManagement.traditional.get("collection").models ? BticinoS4B.solution.energyManagement.traditional.get("collection").models : [];
      for (i=0; i<currentModel.length; i++)
      {
        modelToSave.traditional.traditionalModel.collection.push({
          number          : currentModel[i].get("number")          ? currentModel[i].get("number")          : undefined,
          wizardChoiceCode: currentModel[i].get("wizardChoiceCode")? currentModel[i].get("wizardChoiceCode"): undefined,
          packageClassId  : currentModel[i].get("packageClassId")  ? currentModel[i].get("packageClassId")  : undefined,
          value           : currentModel[i].get("value")           ? currentModel[i].get("value")           : undefined,
          partOfKit       : currentModel[i].get("partOfKit")       ? currentModel[i].get("partOfKit")       : undefined
        });
      }
    }

    /////////////////////////////////////////////////////
    //Optionals//////////////////////////////////////////
    /////////////////////////////////////////////////////
    modelToSave.optionals = [];

    /*
     * Optional packages
     */
    if (BticinoS4B.solution.energyManagement.optionalPackages && BticinoS4B.solution.energyManagement.optionalPackages.get)
    {
      _.each(BticinoS4B.solution.energyManagement.optionalPackages, function(optionalPackage) {
        _.each(optionalPackage.get("products").packagesByOptionalPackageId, function(optionalProduct) {
          if ( optionalProduct.get && optionalProduct.get("value") && (optionalProduct.get("value") > 0) )
          {
            var optionalToAdd             = {};
            optionalToAdd.packageClassId  = optionalProduct.get("packageClassId");
            optionalToAdd.value           = optionalProduct.get("value");
            modelToSave.optionals.push(optionalToAdd);
          }
        });
      });
    }

    return modelToSave;
  };

  // Required, return the module for AMD compliance
  return CalculationClass;

});